<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
    viewBox="-10 0 310 300"
  >
    <path
      fill="currentColor"
      d="M66 37v66l9 9h66v-18h-48l18 -18q13 -13 30 -17.5t34.5 0t30 17t17.5 30t0 35t-18 29.5l-97 98l13 13l98 -97q16 -17 22 -39t0 -44t-22.5 -38.5t-38.5 -22t-44 0t-38 22.5l-14 13v-39h-18z"
    />
  </svg>
</template>